/****************************************************
 * Module Name:  qrScannerModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, TextField, Typography } from "@mui/material";
import QrScanner from "../common/qrScanner";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { LoadingButton } from "@mui/lab";

function QrScannerModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  setMemoId,
  loader
}) {
  const [data, setData] = useState("");
  const [showError, setShowError] = useState(false);
  // eslint-disable-next-line
  const [error, setError] = useState("");

  const [remark, setRemark] = useState("");

  useEffect(() => {
    if (data) {
      saveHandler(data);
      setShow(false);
    }
  }, [data]);

  const saveHandler = (data) => {
    let newData = JSON.parse(window.atob(data));
    let memoid = parseInt(newData.memoid);
    setMemoId(memoid);
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(memoid)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(memoid);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(memoid);
      }
    }
  };

  const saveMemoIdHandler = () => {
    let memoid = remark;
    setMemoId(memoid);
    handleSave(memoid);
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Scan Qr Code validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Scan Qr Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <QrScanner setData={setData} setError={setError} />
          </Box>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Typography variant="p" sx={{ mt: 2, whiteSpace: "nowrap" }}>
              Memo Id
            </Typography>
            <TextField
              id="outlined-multiline-static"
              label="Memo Id"
              fullWidth
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{
            "& .Mui-disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12) !important",
              color: "rgba(0, 0, 0, 0.26) !important"
            }
          }}>
            <LoadingButton
              variant="contained"
              onClick={saveMemoIdHandler}
              type="Submit"
              sx={{ mr: 3 }}
              disabled={remark.length === 0}
              loading={loader}
              loadingPosition="start"
              startIcon={<QrCodeScannerIcon size="large" />}
            >
              Scan
            </LoadingButton>
          </Box>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loader}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default QrScannerModal;
